import { render, staticRenderFns } from "./onlineFiatDeposit.vue?vue&type=template&id=e8c4ea56&scoped=true"
import script from "./onlineFiatDeposit.vue?vue&type=script&lang=js"
export * from "./onlineFiatDeposit.vue?vue&type=script&lang=js"
import style0 from "./onlineFiatDeposit.vue?vue&type=style&index=0&id=e8c4ea56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c4ea56",
  null
  
)

export default component.exports